export const GLASS_CLASS = 'bg-surface/55 backdrop-blur-xl border border-white/10';

export const TILE_CLASS = 'rounded-xl border border-white/10 bg-white/5';

const FLOATING_SURFACE = 'bg-surface/85 backdrop-blur-xl border border-white/10';

export const FLOATING_CLASS = `${FLOATING_SURFACE} shadow-floating`;

export const FLOATING_LG_CLASS = `${FLOATING_SURFACE} lg:shadow-floating`;

export const SCRIM_CLASS = 'bg-black/40 backdrop-blur-sm';

export const OVERLAY_CLASS = 'bg-surface-base/85 backdrop-blur-sm';

export const FLOATING_PILL_CLASS = `${FLOATING_CLASS} pointer-events-auto inline-flex shrink-0 items-center rounded-full text-sm whitespace-nowrap text-text-primary`;
